import axios from 'axios';

export const getChainList = () => axios.get('/backoffice/marketing/chains/');

export const createChain = data => axios.post('/backoffice/marketing/chains/', data);

export const getChain = id => axios.get(`/backoffice/marketing/chains/${id}/`);

export const updateChain = (id, data) => axios.put(`/backoffice/marketing/chains/${id}/`, data);

export const setChainActive = (id, isActive) => axios.patch(`/backoffice/marketing/chains/${id}/`, { isActive });

export const archiveChain = id => axios.delete(`/backoffice/marketing/chains/${id}/`);

export const getChainStats = id => axios.get(`/backoffice/marketing/chains/${id}/stats/`);

export const getChainEnrollments = (id, params) =>
  axios.get(`/backoffice/marketing/chains/${id}/enrollments/`, { params });

export const sendTestEmail = data => axios.post('/backoffice/marketing/test-send/', data);

export const getMarketingMeta = () => axios.get('/backoffice/marketing/meta/');

export const previewAudience = data => axios.post('/backoffice/marketing/audience-preview/', data);
